import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from 'antd';
import { txt } from 'libs/i18n';
export const GLOBAL_SELECTION_LIMIT = 1000;
const GlobalSelectionOption = ({ totalCount }) => {
    if (totalCount === null) {
        return null;
    }
    const isSelectionOverLimit = totalCount > GLOBAL_SELECTION_LIMIT;
    return (_jsx(Tooltip, { trigger: "hover", title: isSelectionOverLimit ? txt('selectionLimit') : null, children: _jsx("button", { type: "button", disabled: isSelectionOverLimit, children: `${txt('selectAllCount')} ${totalCount} ${txt('projectsOutOf')}` }) }));
};
export default GlobalSelectionOption;
